import { NavLink } from 'react-router-dom'

import logo from '../logo.png'

import { FiHome } from 'react-icons/fi'
import { TbDeviceGamepad2 } from 'react-icons/tb'
import { BiUser } from 'react-icons/bi'
import { MdOutlineCategory } from 'react-icons/md'
import { MdOutlineAdminPanelSettings } from 'react-icons/md'
import { VscDiffAdded } from 'react-icons/vsc'
import { MdOutlinePayments } from 'react-icons/md'
import { AiOutlineShopping } from 'react-icons/ai'
import { BsPower } from 'react-icons/bs'
import useAuth from '../hooks/useAuth'
import axios from 'axios'
import { Logout } from '../api/api'
// import { FiSettings } from 'react-icons/fi'


const BuyerSidebar = () => {

     const { setAuth } = useAuth()

     const logoutUser = async (event) => {
          event.preventDefault()
          await axios.post(Logout)
          setAuth({})
          localStorage.removeItem('user')
          window.location.href = '/login'
     }


     return (
          <>
               <nav className='navbarSide'>
                    <div className='logo'>
                         <img src={logo} alt='' />
                    </div>

                    <menu>

                         <NavLink to={'/purchased'}>
                              <AiOutlineShopping />
                              <span>خرید ها</span>
                         </NavLink>

                         <NavLink to={'/profile'}>
                              <BiUser />
                              <span>پروفایل</span>
                         </NavLink>

                         <NavLink to={'/login'} onClick={logoutUser}>
                              <BsPower />
                              <span>خروج</span>
                         </NavLink>

                    </menu>

                    <div className='versionApp'>نسخه: 2.5.0</div>
               </nav>
          </>
     )
}

export default BuyerSidebar